<template lang="html">

  <section class="error-404">

    <section class="intro-xs " :data-bkg="404">
      <div class="col-50 flex column nowrap justify-center align-center animated fadeInLeft">

        <div class="container-text">
          <h1 class="title title-52" v-html="$t('error_404.intro')"></h1>
        </div>


      </div>

    </section>
    <div class="container-text -error">
      <h2 class="title title-52">{{$t('error_404.nombre')}}</h2>
    </div>
     <section class="sec-center pad-sec" >
      <div class="container waypoints" data="fadeInUp">
        <p>{{$t('error_404.texto')}}</p>
        <router-link class="btn btn-dark btn-center" to="/">{{$t('error_404.boton')}}</router-link>
      </div>
    </section>
  </section>

</template>

<script lang="js">
  export default  {
    name: 'error-404',
    props: [],
    mounted() {

    },
    data() {
      return {

      }
    },
    methods: {

    },
    computed: {

    }
  }
</script>

<style scoped>
[data-bkg="404"]{
  background: url(/static/img/bkg/bkg-error.webp) no-repeat center right/50%;
}
.intro .col-50, .intro-xs .col-50{
  background: rgba(5,66,121,0.9);
}
.intro-xs h1{
  bottom: 10%;
}
.container-text.-error{
  background-color:#E6ECF1;
  padding: 120px;
  padding-left: 245px;
  width: 50%;

}
 @media only screen and (max-width: 1401px) {
  .container-text.-error {
    padding: 120px 8%;
  }
 }
 @media only screen and (max-width: 1024px) {
  .container-text.-error {
    background-color: #E6ECF1;
    padding: 120px 5%;
  }
 }
@media only screen and (max-width: 800px) {
  .container-text .title.title-52{
    font-size: 35px;
    line-height: 40px;
  }
  [data-bkg="404"]{
    background-size: contain;
    background-position-x:130%; 
  }
  .error-404 .col-50{
    width: 44%;
  } 
  .container-text.-error{
    width: 44%;
    padding: 120px 4%;
  }
 }
</style>



// WEBPACK FOOTER //
// src/components/views/error-404.vue